let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1nxiB")).then(() => parcelRequire('QZnoq'));